module.exports = __webpack_public_path__ + "img/健康预警机器人ppt-21.d2e98508.jpg";